const storageKey = (eventUUID) => `trackingLink:${eventUUID}`

export function rememberTrackingCode(eventUUID, code) {
  if (!eventUUID || typeof sessionStorage === 'undefined') return
  const value = String(code ?? '').trim()
  if (!value || value === '0' || !/^\d{4,12}$/.test(value)) return
  sessionStorage.setItem(storageKey(eventUUID), value)
}

export function readTrackingCode(eventUUID) {
  if (!eventUUID || typeof sessionStorage === 'undefined') return null
  const value = sessionStorage.getItem(storageKey(eventUUID))
  if (!value || value === '0' || !/^\d{4,12}$/.test(value)) return null
  return value
}
